import { useFlagWithContext } from "@acto/web-common/feature-flags";

export function useRoutePlanningLightEnabled(): boolean {
  return useFlagWithContext("route-planning-light", false);
}
